import React from 'react';
import PropTypes from 'prop-types';
import { useStyles } from './PauseModalStyles';
import { withNamespaces } from 'react-i18next';
import pauseIcon from '../../assets/images/pauseIcon.png';
import CloseIcon from '../UI/svg/CloseIcon';
import ArrowRightIcon from '../UI/svg/ArrowRightIcon';

const { REACT_APP_URL } = process.env;

const PauseModal = ({
	t,
	token,
	onClose
}) => {
	const classes = useStyles();

	return (
		<div className={classes.pauseModal} onClick={onClose}>
			<div className={classes.pauseModalWrapper} onClick={onClose}>
				<div className={classes.pauseModalCloseBtn} onClick={onClose}>
					<CloseIcon />
				</div>

				<div className={classes.pauseModalContent}>
					<img src={pauseIcon} alt="" className={classes.pauseModalImg} />

					<div className={classes.pauseModalTitle}>
						{t('You\'re in Pause Mode')}
					</div>

					<div className={classes.pauseModalDesc}>
						{t('Your premium plan is currently paused, but you’re still protected with our free VPN service. Want your premium features back? Resume anytime in your Admin Panel.')}
					</div>
					
					<a href={REACT_APP_URL + '/pause/resume?token=' + token} className={classes.pauseModalBtn}>
						<span>{t('Resume Services')}</span>
						<ArrowRightIcon />
					</a>
				</div>
			</div>
		</div>
	);
};

PauseModal.propTypes = {
	token: PropTypes.string,
	onClose: PropTypes.func,
	t: PropTypes.func
};

export default withNamespaces()(PauseModal);